import React, { useMemo } from "react";

import { useStateSelector } from "utils/field";
import { categories, getComponentIcon } from "utils/enclosure";
import { getCatComponents, getUserDefinedRooms } from "utils/roomByRoom";
import { mergeExtIntComponents } from "utils/enclosure/components";

import classes from "../ComponentList/style.module.scss";

const STOREY_COMPONENT_TYPES = [
    { type: "wall", label: "Walls" },
    { type: "expFloor", label: "Exposed Floors" },
    { type: "ceiling", label: "Ceilings" },
];

const FOUNDATION_COMPONENT_TYPES = [
    { type: "basement", label: "Basements" },
    { type: "crawlspace", label: "Crawlspaces" },
    { type: "slab", label: "Slabs" },
    { type: "wall", label: "Walls" },
    { type: "ceiling", label: "Ceilings" },
];

/** Component counts (and room count in Room View) next to a storey name */
const StoreyHeaderCounts = ({ catId, showRoomCount = false, onClick, overrides = {} }) => {
    const componentsObject = useStateSelector("model.modelData.components") || {};
    const intComponentsObject = useStateSelector("model.modelData.intComponents") || {};
    const roomSummary = useStateSelector("model.modelData.roomSummary") || {};
    const { id: storeysId } = useStateSelector("model.modelData.specifications.numStoreys") || {};
    
    const { roomCount: roomCountOverride = null, componentItems: componentItemsOverride = null } = overrides || {};

    // Merge components and intComponents for counting
    const mergedExtIntComponents = useMemo(() => mergeExtIntComponents(componentsObject, intComponentsObject), [componentsObject, intComponentsObject]);

    const availableCategories = categories(storeysId).map(({ id }) => id);
    const roomCount = showRoomCount
        ? roomCountOverride ?? getUserDefinedRooms(roomSummary, catId, availableCategories).length
        : 0;

    const componentItems = componentItemsOverride ?? getCatComponents(mergedExtIntComponents, catId, availableCategories);
    const componentTypes = catId === "foundation" ? FOUNDATION_COMPONENT_TYPES : STOREY_COMPONENT_TYPES;
    const typeCounts = componentTypes.map(({ type, label }) => ({
        type,
        label,
        count: componentItems.filter(({ componentType }) => componentType === type).length,
    }));

    return (
        <div
            className={classes.storeyHeaderCounts}
            onClick={(e) => {
                if (onClick) {
                    e.stopPropagation();
                    onClick(e);
                }
            }}
        >
            {showRoomCount && (
                <>
                    <span className={classes.storeyHeaderRoomCount} aria-label={`${roomCount} rooms`}>
                        {roomCount} {roomCount === 1 ? "room" : "rooms"}
                    </span>
                    <span className={classes.storeyHeaderCountDivider} aria-hidden />
                </>
            )}
            {typeCounts.map(({ type, label, count }) => {
                const icon = getComponentIcon(type);
                return (
                    <span key={type} className={classes.storeyHeaderTypeCount} aria-label={`${count} ${label}`}>
                        {icon && <img src={icon} alt="" />}
                        <span>{count}</span>
                    </span>
                );
            })}
        </div>
    );
};

export default StoreyHeaderCounts;
